import { useEffect } from 'react'
import { PlaidLinkOnSuccess, usePlaidLink } from 'react-plaid-link'

type Props = {
  onBack: () => void
  onSuccess: PlaidLinkOnSuccess
  token: string
}

const PlaidSDK = ({ onBack, onSuccess, token }: Props) => {
  const { open, ready } = usePlaidLink({
    onExit: onBack,
    onSuccess,
    token
  })

  useEffect(() => {
    if (!ready) {
      return
    }
    open()
  }, [ready, open])

  return null
}

export default PlaidSDK
